import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class PaymentTimeoutError extends CodedError {
  static get errorName() {
    return errorCodes.paymentTimeoutError.code;
  }

  constructor(message: string = errorCodes.paymentTimeoutError.message) {
    super(message);
    this.code = errorCodes.paymentTimeoutError.code;
    this.message = `${message} ${errorCodes.paymentTimeoutError.code}`;
    this.name = errorCodes.paymentTimeoutError.name;
  }
}
